module.exports = {
	url: '/versante',
	template: require('raw!templates/dining/dining-view.html'),
	controller: DiningController,
	controllerAs: 'diningCtrl',
};

function DiningController($scope, $state, store, $window, contentful, $http, Socialshare) {
	var vm = this;
  $window.scrollTo(0, 0);
	contentful.entries('content_type=diningPage&sys.id=5x9VxyDL5SqWgo0eoEgA8K').then(function(res) {
		// console.log('dining page contentful data',res);
		$scope.dining = res.data.items[0];
		var seoData = res.data.items[0];
		if (seoData.fields.seoTitle) {
			document.title = seoData.fields.seoTitle;
		}
		if (seoData.fields.seoDescription) {
			var meta = document.getElementsByTagName("meta");
			for (var i = 0; i < meta.length; i++) {
				if (meta[i].name.toLowerCase() === "description") {
					meta[i].content = seoData.fields.seoDescription;
				}
			}
		}
	});
	setTimeout(function(){
  var elem = document.querySelector('.carousel');
  var flkty = new Flickity(elem, {
    imagesLoaded: true,
    draggable: false,
    percentPostion: false,
    cellAlign: 'center',
    wrapAround: true,
    lazyLoad: true,
    pageDots: false,
    autoPlay: true
  });
}, 1000);

// document.getElementById("stars").innerHTML = getStars(5);

function getStars(rating) {

  // Round to nearest half
  rating = Math.round(rating * 2) / 2;
  let output = [];

  // Append all the filled whole stars
  for (var i = rating; i >= 1; i--)
    output.push('<span>☆</span>&nbsp;');

  // If there is a half a star, append it
  // if (i == .5) output.push('<i class="fa fa-star-half-o" aria-hidden="true" style="color: gold;"></i>&nbsp;');

  // Fill the empty stars
  for (let i = (5 - rating); i >= 1; i--)
    output.push('☆&nbsp;');

  return output.join('');

}

	vm.trustUrl = "trustUrl";

	trustUrl.$inject = ['$sce'];

	function trustUrl($sce) {
			return function (mediaUrl) {
				return $sce.trustAsResourceUrl(mediaUrl);
			};
		}

		$window.sr = ScrollReveal({ reset: false });
		sr.reveal('.home-load', { duration: 1000 });
		sr.reveal('#cafe', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#pool', { distance: 0, duration: 1000, scale: 1.5 }, 500);
		sr.reveal('#fitness', { distance: 0, duration: 1000, scale: 1.5 }, 500);

		// Open overlay when button is clicked
		$('.show-blue').on('click', function() {
			var contentID = $(this).data('target');
		$('#' + contentID ).toggleClass('reveal');
		$(this).fadeOut(800, 'linear');
		});

		$('.show-white').on('click', function() {
			var contentID = $(this).data('target');
		$('#' + contentID ).toggleClass('reveal');
		$(this).fadeOut(800, 'linear');
		});

		// Close overlay when the outside of menu is clicked
		$('.hide-blue').on('click', function(){
			$('.overlay.bg-blue').addClass('conceal').delay(300).queue(function(){
				$('.overlay.bg-blue').removeClass('conceal');
				$('.overlay.bg-blue').removeClass('reveal');
				$(this).dequeue();
				$(".show-blue").fadeIn(800, 'linear');
			});
		});
		$('.hide-white').on('click', function(){
			$('.overlay.bg-white').addClass('conceal').delay(300).queue(function(){
				$('.overlay.bg-white').removeClass('conceal');
				$('.overlay.bg-white').removeClass('reveal');
				$(this).dequeue();
				$(".show-white").fadeIn(800, 'linear');
			});
		});
	vm.socialShare = function(share) {
	if (share === 'facebook') {
		Socialshare.share({
			'provider': 'facebook',
			'attrs': {
				'socialshareUrl': 'http://peaks-hotel.herokuapp.com/versante',
				'socialshareQuote': 'Peaks Hotel | Versante',
				'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
				'socialsharePopupHeight': '400',
				'socialsharePopupWidth': '400'
			}
		});
	} else if (share === 'twitter') {
		Socialshare.share({
			'provider': 'twitter',
			'attrs': {
				'socialshareUrl': 'http://peaks-hotel.herokuapp.com/versante',
				'socialshareText': 'Peaks Hotel | Versante',
				'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
				'socialsharePopupHeight': '400',
				'socialsharePopupWidth': '400'
			}
		});
	} else if (share === 'pinterest') {
		Socialshare.share({
			'provider': 'pinterest',
			'attrs': {
				'socialshareUrl': 'http://peaks-hotel.herokuapp.com/versante',
				'socialshareText': 'Peaks Hotel | Versante',
				'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
				'socialsharePopupHeight': '400',
				'socialsharePopupWidth': '400'
			}
		});
	} else if (share === 'email') {
		Socialshare.share({
			'provider': 'email',
			'attrs': {
				'socialshare-subject': 'Peaks Hotel | Versante',
				'socialshare-body': 'Take a look at Versante at the Peaks Hotel!'
			}
		});
	}
}
}



// WEBPACK FOOTER //
// ./components/templates/dining/dining-controller.js